<template>
  <section v-once class="single_page" v-if="this.$i18n.locale=='en'">
      <div class="content">
          <!-- Titres, sous-titres et introduction -->
          <h1>Glossary of abbreviations used in Cartoradio</h1>
          <div class="content_text">
              <p>
                  The records for radio stations contain abbreviations. The
                  <a href="#abreviation"> table of abbreviations </a> explains them.
                  <br/>It is supplemented by some
                  <a href="#definitions"> definitions </a> .
              </p>
              <h2>1. List of operators</h2>
              <p>
                  To view the list of operators, click
                  <a href="/cartoradio/web/html/glossaire/pdf/liste_exploitants.pdf" target="_blank"> here </a> (pdf format).
              </p>
              <a id="abreviation" name="abreviation"></a>
              <h2>2. Table of abbreviations (in alphabetical order)</h2>
              <div align="center">
                  <table>
                      <tr>
                          <th>
                              Category
                          </th>
                          <th>
                              Short title
                          </th>
                          <th>
                              Service provided
                          </th>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              ADS-B
                          </td>
                          <td>
                              Automatic dependent surveillance-broadcast
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              AIS
                          </td>
                          <td>
                              Automatic Ship Identification Station
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              ANM or ANT or ANA
                          </td>
                          <td>
                              Navigational aid station (marine or terrestrial or aerian)
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              BLR
                          </td>
                          <td>
                              Local radio loop in the 3 GHz and 26 GHz bands for subscriber connections
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              COM AERTER
                          </td>
                          <td>
                              Aeronautical Terrestrial Communications
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              COM MAR
                          </td>
                          <td>
                              Marine and River Communications
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              COM TER
                          </td>
                          <td>
                              Terrestrial Communications
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              DME
                          </td>
                          <td>
                              Distance measuring equipment
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              EM or EM/RC
                          </td>
                          <td>
                              Non- Frequency modulation broadcasting transmitter
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Hertzian beam
                          </td>
                          <td>
                              FH
                          </td>
                          <td>
                              Hertzian beam
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              FH ABI
                          </td>
                          <td>
                              FH isolated subscriber
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Radio
                          </td>
                          <td>
                              FM
                          </td>
                          <td>
                              Frequency modulation broadcasting
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              GALILEO
                          </td>
                          <td>
                              Satellite-based navigation
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              GONIO
                          </td>
                          <td>
                              Direction finding station
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              GPS or GPS-D
                          </td>
                          <td>
                              Satellite-based navigation
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Mobile Telephony
                          </td>
                          <td>
                              GSM
                          </td>
                          <td>
                              2nd generation radiotelephone 900 or 1800 MHz bands
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              GSM R
                          </td>
                          <td>
                              Digital radiotelephone for the Railway Network
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Mobile Telephony
                          </td>
                          <td>
                              LTE
                          </td>
                          <td>
                              4th generation radiotelephone 700, 800, 1800, 2100 or 2600 MHz bands
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Private mobile networks
                          </td>
                          <td>
                              LTE 2600 P
                          </td>
                          <td>
                              4th generation radiotelephone in the 2600 MHz band for private mobile networks
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Private mobile networks
                          </td>
                          <td>
                              PMR
                          </td>
                          <td>
                              Private mobile networks stations
                          </td>
                      </tr>
                       <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              RADIOASTRO
                          </td>
                          <td>
                              Radio-Astronomy station
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Radio
                          </td>
                          <td>
                              RDF AM
                          </td>
                          <td>
                              Amplitude modulation sound broadcasting
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Television
                          </td>
                          <td>
                              RDF DVB-T
                          </td>
                          <td>
                              Digital terrestrial TV broadcasting
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Radio
                          </td>
                          <td>
                              RDF T-DAB
                          </td>
                          <td>
                              Digital terrestrial sound broadcasting
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Television
                          </td>
                          <td>
                              RDF TV-AN
                          </td>
                          <td>
                              Analogue terrestrial TV broadcasting
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              RDR COT
                          </td>
                          <td>
                              Coastal Radar
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              RDR MTO
                          </td>
                          <td>
                              Weather Radar
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              RDR PFL
                          </td>
                          <td>
                              Wind Profiler Radar
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              REC
                          </td>
                          <td>
                              Receiving station
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              RMU - POCSAG
                          </td>
                          <td>
                              Paging
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              RS
                          </td>
                          <td>
                              Radio probe
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              SAT
                          </td>
                          <td>
                              Standard earth station
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              SAT GEO
                          </td>
                          <td>
                              Earth station to geostationary satellites
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              SAT NGEO
                          </td>
                          <td>
                              Earth station to non-geostationary satellites
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              TELECD
                          </td>
                          <td>
                              Pairing remote control
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              TELEM
                          </td>
                          <td>
                              Telemetry station
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Private mobile networks
                          </td>
                          <td>
                              TETRA or TERAPOL
                          </td>
                          <td>
                              TETRA standard private network
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Mobile Telephony
                          </td>
                          <td>
                              UMTS
                          </td>
                          <td>
                              3rd generation radiotelephone 900 or 2100 MHz bands
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              VOR
                          </td>
                          <td>
                              VHF omnidirectional radio range
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Mobile Telephony
                          </td>
                          <td>
                              5G
                          </td>
                          <td>
                              5th generation radiotelephone 700, 2100 or 3500 MHz bands
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Other stations
                          </td>
                          <td>
                              5G Broadcast Expe
                          </td>
                          <td>
                              TV broadcasting on 5th generation radio network - experimentation
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Mobile Telephony
                          </td>
                          <td>
                              5G NR 26 GHz Expe
                          </td>
                          <td>
                              5th generation radiotelephone in the 26 GHz band for experimentation
                          </td>
                      </tr>
                  </table>
              </div>
              <a name="definitions"></a>
              <h2> 3. Definitions </h2>
              <h3> Frequency bands / ULF, VLF, LF, MF, HF, VHF, UHF, SHF, EHF </h3>
              <p>
              Frequency band:
              <a href="/cartoradio/web/html/glossaire/pdf/tableaubandes.pdf" target="_blank"> symbols and frequency ranges (pdf format)
                      </a> .
              </p>
              <h3> BLR / Local radio loop</h3>
              <p>
                  A radio local loop is used to establish a subscriber connection network by substituting copper wires for radio technology with the advantage of greater flexibility for infrastructure deployment.  The local loop is the set of wired or radio links between the subscriber's station and the subscriber's switch to which it is attached.
                  <br/> WIMAX is a technology used to make BLRs.
              </p>
              <h3> FH / Herztian beam</h3>
              <p>
                Radiocommunications system between two determined fixed points. Radio relay systems transport all kinds of information remotely, using several relays (several FHs) if necessary.
              </p>
              <h3> Goniometry
                      </h3>
              <p>
              Technique for determining the position of a transmitter by triangulation.
              </p>
              <h3> GSM / Global System for Mobile Communication</h3>
              <p>
                This is a standard for radiotelephones. GSM is the name of a standardisation group created in 1982 to determine a European mobile phone standard. This group has formulated the specifications for a mobile cellular radio system that can operate throughout Europe on 900 MHz and 1800 MHz. The GSM standard has been adopted by other countries outside Europe.
              </p>
              <h3> LTE / Long Term Evolution</h3>
              <p>
                Fourth generation mobile telephony system standard, which is essentially characterised by a significant increase in upload and download rates compared to the third generation mobile radio standard. This system operates in the 700, 800, 1800, 2100 and 2600 MHz bands.
              </p>
              <h3> Modulation</h3>
              <p>
                Modification of one of the characteristics of a so-called carrier wave by the signal containing the information. In amplitude modulation, the amplitude, i.e. the magnitude of the carrier wave, is varied in line with the variations in the signal to be transmitted. In frequency modulation, or phase modulation, it is the frequency or phase of the carrier wave that is varied under the same conditions.
              </p>
              <h3> Digital</h3>
              <p>
                As opposed to "analogue" representation of data or physical quantities by means of binary signals (0/1); also refers to systems, devices or processes employing this mode of representation.
              </p>
              <h3> PMR / independent network (Professional mobile radio)</h3>
              <p>
              Professional mobile radio networks.
              <br/>
              <i> For example: Taxis, bus, ambulance, fire brigade, security services, highway maintenance service, etc. networks.</i>
              </p>
              <h3> Protocol</h3>
              <p>
                A document specifying the rationale, objectives, methodology and interpretation of a test or measurement, and also specifying the conditions in which the test or measurement is to be conducted and managed.
              </p>
              <h3> Radiosonde </h3>
              <p>
                Instrument intended to be carried by balloon in the atmosphere, equipped with devices for measuring, for example, one or more meteorological variables (pressure, temperature, humidity, etc.) and provided with a radio transmitter that transmits this information to the observation station.
              </p>
              <h3> RMU - RDS / Unilateral Paging </h3>
              <p>
              One-way paging system without speech transmission (audible, visual, digital or alphanumeric signal).
              <br/>
              <i> For example: ERMES </i>
              </p>
              <h3> Radioelectric Station or base Station </h3>
              <p>
               Site hosting one or more static equipments which allow radiocommunications services in a given coverage area.
              </p>
              <h3> Earth Station </h3>
              <p>
                A station located on the surface of the Earth, intended to communicate with one or more space stations or with one or more satellites.
              </p>
              <h3> Telemetry </h3>
              <p>
                  This involves the remote collection of information collected by sensors or meters.
                  <br/>
                  <i> For example: Satellite telemetry allows the movement of migratory animals to be tracked using sensors attached to them.</i>
              </p>
              <h3> TETRA / Terrestrial Trunk Radio </h3>
              <p>
                  European digital standard for professional radio networks.
                  <br/>
                  <i> For example: Communication between buses, subway trains, railway trains, amongst others.</i>
              </p>
              <h3>UMTS / Universal Mobile Telecommunications System </h3>
              <p>
                  A third-generation (post GSM) radiotelephone standard designed to provide broadband multimedia services through mobile networks: interactive video, Internet access, high-speed data transmission.
              </p>
              <h3>5G</h3>
              <p>
                Fifth generation radiotelephone standard allowing much higher speeds than the fourth generation, very short latency times and an increase in the number of connections per area covered.
              </p>
          </div>
          <div class="content_footer">
              <div class="date_maj_texte"> Last update on July 27, 2021 - © National Agency of Frequencies </div>
          </div>
      </div>
  </section>

  <section v-once class="single_page" v-else>
    <div class="content">
        <!-- Titres, sous-titres et introduction -->
        <h1>Glossaire des abréviations utilisées dans Cartoradio</h1>
        <div class="content_text">
            <p>
                Les fiches associées aux stations radioélectriques contiennent des abréviations. Le
                <a href="#abreviation">tableau des abréviations</a> les explicite.
                <br/> Il est complété par quelques
                <a href="#definitions">définitions</a> .
            </p>
            <h2>1. Liste des exploitants</h2>
            <p>
                Pour consulter la liste des exploitants, veuillez cliquer
                <a href="/cartoradio/web/html/glossaire/pdf/liste_exploitants.pdf" target="_blank">ici</a> (format pdf).
            </p>
            <a id="abreviation" name="abreviation"></a>
            <h2>2. Tableau des abréviations (par ordre alphabétique)</h2>
            <div align="center">
                <table>
                    <tr>
                        <th>
                            Catégorie
                        </th>
                        <th>
                            Intitulé court
                        </th>
                        <th>
                            Service rendu
                        </th>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            ADS-B
                        </td>
                        <td>
                            Station de surveillance automatique des informations de bord
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            AIS
                        </td>
                        <td>
                            Station d'identification automatique de navires
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            ANM ou ANT ou ANA
                        </td>
                        <td>
                            Station d'aide à la navigation maritime ou terrestre ou aérienne
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            BLR
                        </td>
                        <td>
                            Boucle locale radio dans les bandes des 3 GHz et des 26 GHz pour raccordement d'abonnés
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            COM AERTER
                        </td>
                        <td>
                            Communications aéronautiques terrestres
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            COM MAR
                        </td>
                        <td>
                            Communications maritimes et fluviales
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            COM TER
                        </td>
                        <td>
                            Communications terrestres
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            DME
                        </td>
                        <td>
                            Mesure de Distance
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            EM ou EM/RC
                        </td>
                        <td>
                            Emetteur de radiodiffusion sonore autre que bande FM
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Faisceaux Hertziens
                        </td>
                        <td>
                            FH
                        </td>
                        <td>
                            Faisceau Hertzien
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            FH ABI
                        </td>
                        <td>
                            FH Abonné isolé
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Radio
                        </td>
                        <td>
                            FM
                        </td>
                        <td>
                            Radiodiffusion en modulation de fréquence
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            GALILEO
                        </td>
                        <td>
                            Navigation par satellite
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            GONIO
                        </td>
                        <td>
                            Station de goniométrie
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            GPS ou GPS-D
                        </td>
                        <td>
                            Navigation par satellite
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Téléphonie mobile
                        </td>
                        <td>
                            GSM
                        </td>
                        <td>
                            Radiotéléphonie 2ème génération bandes 900 ou 1800 MHz
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            GSM R
                        </td>
                        <td>
                            Radiotéléphonie numérique pour le Réseau Ferré
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Téléphonie mobile
                        </td>
                        <td>
                            LTE
                        </td>
                        <td>
                            Radiotéléphonie 4ème génération bandes 700, 800, 1800, 2100 ou 2600 MHz
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Réseaux mobiles privés
                        </td>
                        <td>
                            LTE 2600 P
                        </td>
                        <td>
                            Radiotéléphonie 4ème génération bande 2600 MHz pour les réseaux mobiles privés
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Réseaux mobiles privés
                        </td>
                        <td>
                            PMR
                        </td>
                        <td>
                            Station d'un réseau privé
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            RADIOASTRO
                        </td>
                        <td>
                            Station de radioastronomie
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Radio
                        </td>
                        <td>
                            RDF AM
                        </td>
                        <td>
                            Radiodiffusion sonore en modulation d'amplitude
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Télévision
                        </td>
                        <td>
                            RDF DVB - T
                        </td>
                        <td>
                            Radiodiffusion TV numérique de terre
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Radio
                        </td>
                        <td>
                            RDF T - DAB
                        </td>
                        <td>
                            Radiodiffusion sonore numérique terrestre
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Télévision
                        </td>
                        <td>
                            RDF TV-AN
                        </td>
                        <td>
                            Radiodiffusion TV analogique de terre
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            RDR COT
                        </td>
                        <td>
                            Radar côtier
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            RDR MTO
                        </td>
                        <td>
                            Radar de Météorologie
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            RDR PFL
                        </td>
                        <td>
                            Radar Profileur de vent
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            REC
                        </td>
                        <td>
                            Station de réception
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            RMU - POCSAG
                        </td>
                        <td>
                            Radiomessagerie
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            RS
                        </td>
                        <td>
                            Radio sonde
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            SAT
                        </td>
                        <td>
                            Station terrienne standard
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            SAT GEO
                        </td>
                        <td>
                            Station terrienne vers satellites géostationnaires
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            SAT NGEO
                        </td>
                        <td>
                            Station terrienne vers satellites non géostationnaires
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            TELECD
                        </td>
                        <td>
                            Télécommande d'appareillage
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            TELEM
                        </td>
                        <td>
                            Station de télémesure
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Réseaux mobiles privés
                        </td>
                        <td>
                            TETRA ou TETRAPOL
                        </td>
                        <td>
                            Réseau privé à la norme TETRA ou TETRAPOL
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Téléphonie mobile
                        </td>
                        <td>
                            UMTS
                        </td>
                        <td>
                            Radiotéléphonie 3ème génération bandes 900 ou 2100 MHz
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            VOR
                        </td>
                        <td>
                            Radiophare omnidirectionnel
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Téléphonie mobile
                        </td>
                        <td>
                            5G
                        </td>
                        <td>
                            Radiotéléphonie 5ème génération bandes 700, 2100 ou 3500 MHz
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Autres stations
                        </td>
                        <td>
                            5G Broadcast Expe
                        </td>
                        <td>
                            Radiodiffusion TV sur réseau de radiotéléphonie 5ème génération expérimentation
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Téléphonie mobile
                        </td>
                        <td>
                            5G NR 26 GHz Expe
                        </td>
                        <td>
                            Radiotéléphonie 5ème génération bande 26 GHz pour expérimentation
                        </td>
                    </tr>
                </table>
            </div>
            <a name="definitions"></a>
            <h2>3. Définitions</h2>
            <h3>Bandes de fréquences / ULF, VLF, LF, MF, HF, VHF, UHF, SHF, EHF</h3>
            <p>
                Bande de fréquences :
                <a href="/cartoradio/web/html/glossaire/pdf/tableaubandes.pdf" target="_blank">symboles et gammes de fréquences (format pdf)</a> .
            </p>
            <h3>BLR / Boucle locale radio</h3>
            <p>
                Une boucle locale radio permet d'établir un réseau de raccordement d'abonnés en substituant aux fils de cuivre une technologie radio offrant l'avantage d'une plus grande souplesse pour le déploiement des infrastructures. La boucle locale est l'ensemble des liens filaires ou radioélectriques existant entre le poste de l'abonné et le commutateur d'abonnés auquel il est rattaché.
                <br/> Le WIMAX est une technologie utilisée pour réaliser des BLR.
            </p>
            <h3>FH / faisceau herztien</h3>
            <p>
                Système de radiocommunication entre deux points fixes déterminés. Les faisceaux hertziens transportent à distance toutes sortes d'informations, en utilisant si nécessaire plusieurs relais (plusieurs FH).
            </p>
            <h3>Goniométrie</h3>
            <p>
                Technique pour déterminer la position d'un émetteur par triangulation.
            </p>
            <h3>GSM / Global System for Mobile communication</h3>
            <p>
                Il s'agit d'une norme pour le radiotéléphone mobile. GSM est le nom d'un groupe de normalisation créé en 1982 pour déterminer une norme européenne de téléphone mobile. Ce groupe a formulé les spécifications pour un système radio cellulaire mobile pouvant fonctionner dans toute l'Europe sur 900 MHz et 1 800 MHz. La norme GSM a été adoptée par d'autres pays en dehors de l'Europe.
            </p>
            <h3>LTE / Long Term Evolution</h3>
            <p>
                Norme de radiotéléphonie mobile de quatrième génération, qui se caractérise essentiellement par une augmentation significative des débits montants et descendants par rapport à la radiotéléphonie de troisième génération. Ce système fonctionne dans les bandes 700, 800, 1800, 2100 et 2600 MHz.
            </p>
            <h3>Modulation</h3>
            <p>
                Modification d'une des caractéristiques d'une onde dite porteuse, par le signal qui contient l'information. Dans la modulation d'amplitude, on fait varier l'amplitude, c'est-à-dire la grandeur de l'onde porteuse, au rythme des variations du signal à transmettre. Dans la modulation de fréquence, ou la modulation de phase, c'est la fréquence ou la phase de l'onde porteuse qu'on fait varier dans les mêmes conditions.
            </p>
            <h3>Numérique</h3>
            <p>
                Se dit, par opposition à "analogique" de la représentation de données ou de grandeurs physiques au moyen de signaux binaires (0/1) ; se dit aussi des systèmes, dispositifs ou procédés employant ce mode de représentation. ("Digital" en anglais).
            </p>
            <h3>PMR / réseau indépendant (Professional mobile radio)</h3>
            <p>
                Réseaux radio mobiles professionnels.
                <br/>
                <i>Exemple : Réseaux de taxis, de bus, d'ambulance, de pompiers, de services de sécurité, des services de maintenance des autoroutes, etc.</i>
            </p>
            <h3>Protocole</h3>
            <p>
                Document précisant la justification, les objectifs, la méthodologie et l'interprétation d'un essai ou d'une mesure, et précisant également les conditions dans lesquelles cet essai doit être réalisé et géré.
            </p>
            <h3>Radiosonde</h3>
            <p>
                Instrument destiné à être emporté par ballon dans l'atmosphère, muni de dispositifs pour mesurer, par exemple, une ou plusieurs variables météorologiques (pression, température, humidité, etc.) et pourvu d'un émetteur radioélectrique qui transmet ces renseignements à la station d'observation.
            </p>
            <h3>RMU - RDS / Radiomessagerie unilatérale</h3>
            <p>
                Système d'appel de personnes unidirectionnel, sans transmission de parole (signal sonore, visuel, numérique ou alphanumérique).
                <br/>
                <i>Exemple : ERMES</i>
            </p>
            <h3>Station radio électrique ou station de base</h3>
            <p>
                Site hébergeant un ou plusieurs équipements fixes permettant d’assurer un service de radiocommunication dans une zone donnée de couverture.
            </p>
            <h3>Station terrienne</h3>
            <p>
                Station située à la surface de la Terre, destinée à communiquer avec une ou plusieurs stations spatiales ou avec un ou plusieurs satellites.
            </p>
            <h3>Télémesure</h3>
            <p>
                Il s'agit de recueillir à distance des informations collectées par des capteurs ou des compteurs.
                <br/>
                <i>Exemple : Une télémesure satellitaire permet de suivre le mouvement des animaux migrateurs grâce à des capteurs fixés sur eux.</i>
            </p>
            <h3>TETRA / Terrestrial Trunk Radio</h3>
            <p>
                Norme européenne numérique pour les réseaux radio professionnels.
                <br/>
                <i>Exemple : Communication entre bus, rames de métro, train, entre autres.</i>
            </p>
            <h3>UMTS / Universal Mobile Telecommunications System</h3>
            <p>
                Norme de radiotéléphone de troisième génération (post GSM) destiné à fournir des services large bande multimédia à travers des réseaux mobiles : vidéo interactive, accès à Internet, transmission de données à grande vitesse.
            </p>
            <h3>5G</h3>
            <p>
                Norme de radiotéléphonie de cinquième génération permettant des débits largement supérieurs à ceux de la quatrième génération, des temps de latence très courts et une augmentation du nombre de connexions par surface couverte.
            </p>
        </div>
        <div class="content_footer">
            <div class="date_maj_texte">Dernière actualisation le 27 juillet 2021 - © Agence Nationale des Fréquences</div>
        </div>
    </div>
  </section>

</template>

<script>

export default {
  name: 'Comprendre',
  components: { },
  data() {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
